<template>
  <div class="teacher-management">
    <el-form :inline="true" size="mini">
      <el-form-item label="学校名称">
        <span>{{ this.$route.query.name }}</span>
      </el-form-item>

      <!-- <el-button
        style="float: right;margin-right:10px;"
        size="mini"
        round
        type="info"
        @click="AddSchoolTime"
      >
        添加学生时长
        <i class="el-icon-d-arrow-right el-icon--right"></i>
      </el-button>-->
    </el-form>
    <div class="table-style">
      <!-- <el-button size="mini" type="primary" icon="el-icon-plus">教师管理</el-button> -->
      <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (pageNum - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column width="100" label="头像" align="center">
          <template slot-scope="scope">
            <el-image style="width: 30px; height: 30px" :src="scope.row.userImageUrl" fit="cover"></el-image>
          </template>
        </el-table-column>

        <el-table-column align="left" prop="realName" label="姓名"></el-table-column>
        <el-table-column align="left" prop="state" label="状态"></el-table-column>

        <el-table-column align="left" prop="name" label="平台账号"></el-table-column>

        <el-table-column align="left" prop="createdTime" label="创建时间"></el-table-column>

        <el-table-column align="left" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="updatePrincipal(scope.row)">状态</el-button>
            <el-button type="text" size="mini" @click="del(scope.row)">移除教师身份</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" style="padding-top:10px;text-align:right">
        <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page.sync="pageNum" :page-size="pageSize" :page-sizes="[20,30,50,100,200]" layout="sizes,total, prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 是否离职 -->
    <el-dialog title="提示" :visible.sync="dialogVisible1" width="30%">
      <el-form ref="form" :model="formGad" label-width="80px">
        <el-form-item label="在职状态">
          <el-select v-model="formGad.state" placeholder="请选择">
            <el-option v-for="item in stateList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="updateState">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  //  schoolTchList,
  updateState,
  // adminDeleteUserTchRole,
} from '@/api/admin'
import {
  api_userTchManageTchRoleUserList,
  api_tchManageDeleteUserTchRole,
} from '@/api/javaApi'
export default {
  data() {
    return {
      educational_institution_id: '',
      tableData: [],
      pageNum: 1,
      pageSize: 100,
      total: 0,
      user_id: '',
      formGad: {
        state: '',
      },
      dialogVisible1: false,
      stateList: [
        {
          value: '在职',
          label: '在职',
        },
        {
          value: '离职',
          label: '离职',
        },
      ],
    }
  },
  created() {
    this.educational_institution_id = this.$route.query.id
    console.log(this.$route.query.name, 456456)
  },
  mounted() {
    this.schoolTchList()
  },
  methods: {
    del(row) {
      console.log(row)
      this.$confirm('是否确认移除教师身份?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          api_tchManageDeleteUserTchRole({
            userId: row.id,
            eduId: row.eduId,
          }).then(() => {
            this.schoolTchList()

            this.$message({
              type: 'success',
              message: '移除成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消移除',
          })
        })
    },
    schoolTchList() {
      api_userTchManageTchRoleUserList({
        eduId: this.educational_institution_id,
        pageRequest: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        },
      }).then((res) => {
        this.tableData = res.content
        this.total = res.totalSize
      })
    },
    handleCurrentChange(page) {
      this.pageNum = page
      this.schoolTchList()
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageNum = 1;
      this.schoolTchList()
    },
    updatePrincipal(row) {
      this.user_id = row.id
      this.formGad.state = row.state

      this.dialogVisible1 = true
    },
    updateState() {
      updateState({
        userId: this.user_id,
        state: this.formGad.state,
      }).then((res) => {
        console.log(res)
        this.dialogVisible1 = false
        this.schoolTchList()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.teacher-management {
  height: 100%;
  box-sizing: border-box;
  padding-left: 20px;
  padding-top: 20px;
  margin: 10px;
  border-radius: 5px;
  background-color: #fff;
  .form-style {
  }
  .btn {
    margin-top: 10px;
  }
}
</style>
